// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","bloombergExcerpt":"_1a6MV7VEIchDWC9vgJ00Gk","bloombergExcerptImageWrapper":"J8kbX_sE6vbhXzdJRNLLB"};